import type { IconData } from '@stacksjs/iconify-core'

export const esCt4x3: IconData = {
  "body": "<path fill=\"#fcdd09\" d=\"M0 0h640v480H0z\"/><path stroke=\"#da121a\" stroke-width=\"60\" d=\"M0 90h810m0 120H0m0 120h810m0 120H0\" transform=\"scale(.79012 .88889)\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default esCt4x3
